import { render, staticRenderFns } from "./BudgetsPreview.vue?vue&type=template&id=3358edba&scoped=true&"
import script from "./BudgetsPreview.vue?vue&type=script&lang=js&"
export * from "./BudgetsPreview.vue?vue&type=script&lang=js&"
import style0 from "./BudgetsPreview.vue?vue&type=style&index=0&id=3358edba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3358edba",
  null
  
)

export default component.exports